// анимированное сердце для Я(сердце)Томск

export default function PulsatingHeart() {
  return (
    <span className="inline-block animate-pulse" aria-hidden="true">
      ❤️
    </span>
  );
}
